import React, {useEffect, useContext} from 'react'
import {Button} from 'antd'
import {Arguments} from "../common/Arguments";
import {sideMenuContext} from "../../../router/IndexRouter";
import {GetApiMethod} from "../common/ApiMethod";
import TableComponent from "../common/TablePaginationComponent";
import {camelObj} from "../common/ConversionMethod";
import SearchBox from "../common/SearchBoxComponent";


export default function SocietyRecognitionAdmin(props) {
    const {dataSource, setDataSource, setCopyDataSource, setCurrentItem} = useContext(sideMenuContext);
    const getApi = Arguments.host + "/society_organization/admin/api!organizationAndPrize.do";

    useEffect(() => {
        setDataSource([]);
        GetApiMethod({getApi, setDataSource, setCopyDataSource});
    }, [getApi])

    const detailClick = (item) => {
        setCurrentItem(camelObj(item));
        window.open(Arguments.reactUrl + "/society/society-recognition-admin/detail", "_self");
    }

    const columns = [
        {
            title: '序号',
            dataIndex: 'showIndex',
            width: 100,
            sorter: (a, b) => a.showIndex - b.showIndex,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '社会组织',
            dataIndex: 'organization_name',
            width: 240
        },
        {
            title: '授奖年度',
            dataIndex: 'prize_year',
            responsive: ['lg'],
            width: 100,
        },
        {
            title: '授奖名称',
            dataIndex: 'prize_name',
            responsive: ['lg'],
            width: 280,
        },
        {
            title: "备注",
            dataIndex: 'prize_memo',
            responsive: ['lg']
        },
        {
            title: "操作",
            width: 140,
            render: (item) => (
                <Button type="link" onClick={() => detailClick(item)}>查看详情</Button>
            )
        }
    ];

    const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}))

    return (
        <>
            <SearchBox placeholder="请输入社会组织关键字"/>
            <TableComponent dataSource={indexDataSource} columns={columns}/>
        </>
    )
}

